export const moveUntranslatedToFront = (resources: OtherLang[] | any[]) => {
  return resources.sort((a, b) => {
    if (a.target === '' && b.target !== '') {
      return -1;
    }
    return 0;
  });
};
